import { Component, OnInit , EventEmitter} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { EventService } from '../event.service';
import { PageService } from '../../common/page.service';
import {MdSnackBar} from '@angular/material';


@Component({
  selector: 'app-global-page-form',
  templateUrl: './global-page-form.component.html',
  styleUrls: ['./global-page-form.component.css', '../admin.css'],
  providers: [PageService, EventService],
})
export class GlobalPageFormComponent implements OnInit {

 pageForm: any;
 event: any;
 pageId: any;
 page: any;
 spinner: boolean = false;
 

  constructor(private formBuilder: FormBuilder, private pageService: PageService, private eventService: EventService, private activatedRoute: ActivatedRoute, private snackBar: MdSnackBar){
  this.pageForm = this.formBuilder.group({
   'id': [''],
   'title': ['', Validators.required],
   'displayFor': [''],
   'publish': [''],
   'content': [''],
   'mobileContent': [''],
   'androidContent':['']
  });
  this.page = this.pageForm.value;
  }

  ngOnInit() {
  }
  onSave = new EventEmitter();

  savePage() {
   this.spinner = true;
   var params = this.pageForm.value;
   this.pageService.saveGlobalPage(params).subscribe(response => {
    this.spinner = false;
    if(response.status)
    this.onSave.emit();
    else
    this.snackBar.open(response.msg, '', {duration: 4000});
   });
 }
 formValid(frm){
  var flag = true;
  if(!this.pageForm.valid)
  flag = false;
  return flag;
 }



}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/global-page-form/global-page-form.component.ts